import { render, staticRenderFns } from "./JournalBase.vue?vue&type=template&id=79b2d063&"
import script from "./JournalBase.vue?vue&type=script&lang=js&"
export * from "./JournalBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports